import { styled } from "@mui/system"
import { Box, BoxProps } from "@mui/material"

interface BarProps extends BoxProps {
  variant: string
}

export const Bar = styled(Box)<BarProps>(({ variant }) => ({
  display: "flex",
  padding: "12px 32px",
  justifyContent: "flex-start",
  "& > img": {
    cursor: "pointer",
  },
  ...((variant === "landing" || variant === "login") && {

  }),
}))
